import {Injectable} from "@angular/core";
import {User} from "@app/core/user/domain/entities/user";
import {UserLocal} from "@app/core/user/domain/user.local";

@Injectable({
    providedIn: 'root',
})

export class GetUserUseCase {

    constructor(private localStorage:UserLocal) {}

    execute(): User | null{
        return this.localStorage.getUser()
    }
}